import { getParsedDateUntilToday } from 'utils/dateUtils'

const selectData = (state) => state.resolutioncenter.remediatedIncidents.data
const selectLoader = (state) => state.resolutioncenter.remediatedIncidents.loader
const selectError = (state) => state.resolutioncenter.remediatedIncidents.error

const selectPage = (state) => state.resolutioncenter.remediatedIncidents.page
const selectMessage = (state) => state.resolutioncenter.remediatedIncidents.message
const selectGeneralFilter = (state) => state.resolutioncenter.remediatedIncidents.generalFilter
const selectDateFilter = (state) => state.resolutioncenter.remediatedIncidents.dateFilter
const selectSearch = (state) => state.resolutioncenter.remediatedIncidents.search
const selectDetectedByFilter = (state) =>
  state.resolutioncenter.remediatedIncidents.detectedByFilter

const selectParsedDate = (state) => {
  const currentDateFilter = selectDateFilter(state)
  return getParsedDateUntilToday(currentDateFilter)
}

export {
  selectData,
  selectLoader,
  selectError,
  selectPage,
  selectMessage,
  selectGeneralFilter,
  selectDateFilter,
  selectSearch,
  selectDetectedByFilter,
  selectParsedDate,
}
